// See https://docs.lightstep.com/docs/use-tags-to-find-issues-fast#useful-tags
// and https://github.com/opentracing/specification/blob/master/semantic_conventions.md

// These should be considered the "Default Spotify Web" tracing tags.

export const WEBGATE_SERVICE = 'webgate.service';
export const SERVICE_VERSION = 'service.version';
export const SERVICE_HASH = 'service.hash';

export const HTTP_MODE = 'http.mode';
export const HTTP_HASH = 'http.hash';
export const HTTP_HREF = 'http.href';
export const HTTP_PROTOCOL = 'http.protocol';
export const HTTP_ORIGIN = 'http.origin';
export const HTTP_HOST = 'http.host';
export const HTTP_HOSTNAME = 'http.hostname';
export const HTTP_PORT = 'http.port';
export const HTTP_PATHNAME = 'http.pathname';
export const HTTP_SEARCH = 'http.search';

export const HTTP_RES_REDIRECTED = 'http.res.redirected';
export const HTTP_RES_TYPE = 'http.res.type';
export const HTTP_RES_URL = 'http.res.url';
export const HTTP_RES_OK = 'http.res.ok';

// Tempting to make this http.res.status_code_group, but http.status_code_group
// matches the opentracing spec for http.status_code:
// https://github.com/opentracing/specification/blob/master/semantic_conventions.md
export const HTTP_STATUS_CODE_GROUP = 'http.status_code_group';

// Allows for grouping operations, which may have a service in the name, by
// their "kind" (.e.g. fetch, xhr, hermes, etc)
export const OPERATION_KIND = 'operation.kind';

export const NAVIGATOR_ONLINE = 'navigator.onLine';
export const NAVIGATOR_USER_AGENT = 'navigator.user_agent';
export const NAVIGATOR_WEBDRIVER = 'navigator.webdriver';
